import { ReactNode, useCallback, useRef } from 'react'
import styled from 'styled-components'
import { Customer, ISellerTableProductItem } from '../../../../../modules/API/Seller/models/tableData'
import { Panel, Toolbar } from '../../../../../generic/grid-table'
import { TableScroll } from '../../../../../generic/grid-table/components/GridTable'
import SellerHead from './SellerHead'
import SellerBody from './SellerBody'
import { ISellerChangeOrderProps } from '../types/handlerChangeOrder'

// The frozen columns are pinned by a main-thread scroll handler (transform).
// `-webkit-overflow-scrolling: touch` runs scrolling on iOS's async thread,
// which the handler can't keep up with → the frozen columns lag on momentum
// fling. `auto` keeps this one scroll container on the main thread so the
// transform tracks the scroll tightly. Scoped to the seller table only; the
// other grid modules keep momentum scrolling.
const SellerScroll = styled(TableScroll)`
  -webkit-overflow-scrolling: auto;
`

type Props = {
  list: ISellerTableProductItem[],
  meta: Customer[],
  count?: number,
  toolbar?: ReactNode,
  openTahazitRemarkModal: (id: string, growerID: number, customerID: number, qty: number, tahazitRemark: string) => void,
  handleSelectProduct: (item: ISellerTableProductItem) => void,
  handleChangeOrder: ((props: ISellerChangeOrderProps) => void)
  openFreightCompanyModal: (id: string, growerID: number, customerID: number, freightCompanyID: number, qty: number, remark: string) => void
  openRemarkModal: (id: string, growerID: number, customerID: number, freightCompanyID: number, qty: number, remark: string) => void
}

const SellerTable = ({
  list,
  meta,
  count,
  toolbar,
  handleChangeOrder,
  openFreightCompanyModal,
  openRemarkModal,
  handleSelectProduct,
  openTahazitRemarkModal
}: Props) => {
  // Manual frozen-column freeze (position: sticky is unreliable on iOS Safari
  // here): on horizontal scroll we publish the scroll offset into the
  // --freeze-x CSS variable, and the frozen cells translateX by it to stay
  // pinned to the right edge. rAF-throttled to one write per frame.
  const scrollRef = useRef<HTMLDivElement>(null)
  const frameRef = useRef<number | null>(null)
  const handleScroll = useCallback(() => {
    if (frameRef.current !== null) return
    frameRef.current = requestAnimationFrame(() => {
      frameRef.current = null
      const el = scrollRef.current
      if (el) el.style.setProperty('--freeze-x', `${el.scrollLeft}px`)
    })
  }, [])
  return (
    <Panel>
      <Toolbar title="סידור יום" count={count ?? list.length}>
        {toolbar}
      </Toolbar>
      <SellerScroll ref={scrollRef} onScroll={handleScroll}>
        <table>
          <SellerHead
            list={meta}
          />
          <SellerBody
            list={list}
            handleChangeOrder={handleChangeOrder}
            openFreightCompanyModal={openFreightCompanyModal}
            openRemarkModal={openRemarkModal}
            handleSelectProduct={handleSelectProduct}
            openTahazitRemarkModal={openTahazitRemarkModal}
          />
        </table>
      </SellerScroll>
    </Panel>
  )
}

export default SellerTable
